import * as React from 'react';
import * as styles from './styles.css';

import { Header2, InlineText1 } from '@cian/ui-kit/typography';

export interface IContentSectionProps {
  title: string;
  description?: string;
  mainContent: React.ReactNode;
  chart: React.ReactNode;
}

export function ContentSection({ title, description, mainContent, chart }: IContentSectionProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['top']}>
        <div className={styles['text-content']}>
          <h2 className={styles['title']}>
            <Header2>{title}</Header2>
          </h2>
          {description && (
            <div className={styles['description']}>
              <InlineText1 color="black_60">{description}</InlineText1>
            </div>
          )}
        </div>
        <div className={styles['main-content']}>{mainContent}</div>
      </div>
      <div className={styles['chart']}>{chart}</div>
    </div>
  );
}
